import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router';
import { RoleGuard } from '@/components/layout/RoleGuard';
import { cn } from '@/lib/cn';
import { Package, List, History } from 'lucide-react';

export const Route = createFileRoute('/_app/inventory')({
  component: () => (
    <RoleGuard allowedRoles={['supervisor', 'owner', 'operator']}>
      <InventoryLayout />
    </RoleGuard>
  ),
});

interface TabDef {
  name: string;
  href: string;
  icon: typeof Package;
  exact?: boolean;
}

const tabs: TabDef[] = [
  { name: 'Stock', href: '/inventory', icon: Package, exact: true },
  { name: 'Items', href: '/inventory/items', icon: List },
  { name: 'Transactions', href: '/inventory/transactions', icon: History },
];

function InventoryLayout() {
  const location = useLocation();

  return (
    <div className="space-y-6">
      {/* Page header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Inventory</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage stock levels, items, and track inventory movements
        </p>
      </div>

      {/* Tab navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => {
            const isActive = tab.exact
              ? location.pathname === tab.href
              : location.pathname.startsWith(tab.href);

            return (
              <Link
                key={tab.name}
                to={tab.href as '/inventory'}
                className={cn(
                  'flex items-center gap-2 border-b-2 px-1 py-3 text-sm font-medium transition-colors',
                  isActive
                    ? 'border-primary-600 text-primary-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                )}
              >
                <tab.icon className="h-4 w-4" />
                {tab.name}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Child routes */}
      <Outlet />
    </div>
  );
}
